<template>
  <v-app class="app-shell">
    <Header/>
    <Sidebar v-if="oidcIsAuthenticated"/>
    <v-main>
      <v-container fluid class="main-container">
        <router-view></router-view>
      </v-container>
    </v-main>
    <snack-notice/>
    <Footer/>
    <modal-prompter />
  </v-app>
</template>

<script>
import Header from './components/core/Header';
import Sidebar from './components/core/Sidebar';
import Footer from './components/core/Footer';
import SnackNotice from './components/core/SnackNotice.vue';
import {mapGetters} from 'vuex'
import ModalPrompter from './components/core/ModalPrompter.vue';
//import { HubConnectionBuilder } from "@microsoft/signalr";

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Footer,
    SnackNotice,
    ModalPrompter
  },
  computed: {
    ...mapGetters([
      'oidcIsAuthenticated',
      'oidcUser'
    ])
  },
  data(){
    return {
      items: [
        { title: 'Proyectos', icon: 'folder' },
        { title: 'Mis Proyectos', icon: 'folder' },
        { title: 'Cuenta', icon: 'account_circle' },
      ],
    }
  },
  watch:{
    oidcIsAuthenticated:function(newVal){
      if(newVal){
        this.$cf_api.getUserRole().then(r=>{
          this.$store.commit('setUserRole', r.data)
          this.$store.dispatch('connectToHub')
        }).catch(e => {
          console.log('Error retrieving user role. Error: ',e)
        })
        this.$cf_api.getUserFinancialAccounts(this.oidcUser.name).then(response=>{
          this.$store.commit('setUserAccounts', response.data)
        }).catch(e=>{
          console.log('Error retreiving user account info: ',e)
        })
      }else {
        this.$store.commit('clearUserRole')
      }
    }
  }
};
</script>

<style>
html, body { font-size:16px; background:#f8f5ef; }
* { box-sizing:border-box; }
a, button, [role="button"] { touch-action:manipulation; }
a:focus-visible, button:focus-visible, [role="button"]:focus-visible { outline:3px solid #e76f51!important; outline-offset:3px; }
html { scroll-behavior:smooth; }
.app-shell { background:#f8f5ef!important; }
.main-container { padding:0!important; }
@media (prefers-reduced-motion: reduce) { html { scroll-behavior:auto; } *, *::before, *::after { animation-duration:.01ms!important; animation-iteration-count:1!important; transition-duration:.01ms!important; } }
</style>
